import { GenericLazyString, gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import zxcvbn from 'zxcvbn';
import {
    PASSWORD_MIN_LENGTH,
    PASSWORD_STRENGTH_LABELS,
    PASSWORD_TOO_SHORT,
} from './constants';

export const getPasswordStrength = (inputPassword?: string) => {
    /*
    Calculate the strength statistics for input passwords with zxcvbn
    */

    let passwordStrengthLabel = PASSWORD_TOO_SHORT;
    let passwordScore = 0;
    let isPasswordValidLength = false;
    let fullPasswordStats;

    if (inputPassword && inputPassword.length >= PASSWORD_MIN_LENGTH) {
        fullPasswordStats = zxcvbn(inputPassword);
        passwordStrengthLabel =
            PASSWORD_STRENGTH_LABELS[fullPasswordStats.score];
        passwordScore = fullPasswordStats.score;

        // set the strength bar to be 25% of 25% for a score of zero ("very weak")
        // so the user gets some feedback
        if (passwordScore === 0) {
            passwordScore = 0.25;
        }

        isPasswordValidLength = true;
    }

    return {
        passwordScore,
        passwordStrengthLabel,
        isPasswordValidLength,
    };
};

export const getPasswordStrengthLabelMarkup = (
    passwordStrengthLabel: GenericLazyString,
    isPasswordValidLength?: boolean,
) => {
    const passwordStrengthLabelClassName = classNames({
        'eds-text-weight--heavy': isPasswordValidLength,
    });
    const gettextWithMarkup = {
        // Translators: This indicates password strength (e.g. "Your password is weak")
        __html: gettext(
            '<span>Your password </span><span class="%(passwordStrengthLabelClassName)s">%(passwordStrengthLabel)s</span>',
            {
                passwordStrengthLabelClassName,
                passwordStrengthLabel,
            },
        ).toString(),
    };

    return gettextWithMarkup;
};
